module.exports = __webpack_public_path__ + "img/first_down_failed.24e238a6.jpg";